import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SettingsConfig } from './settings.config';

@Injectable({ providedIn: 'root' })
export class SettingsConfigHttpService {
  private appConfig: SettingsConfig;

  constructor(private injector: Injector) {}

  loadAppConfig() {
    const http = this.injector.get(HttpClient);
    return http
      .get('assets/settings.json')
      .toPromise()
      .then((data) => {
        this.appConfig = <SettingsConfig>data;
      });
  }

  get config(): SettingsConfig {
    return this.appConfig;
  }
}
